import T from 'i18n-react';

import Texts from '../texts.json';

T.setTexts(Texts);

export default T;
